// src/App.js

import React, { Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import Login from "./components/Login";
import DoctorDashboard from "./components/DoctorDashboard";
import ParentDashboard from "./components/ParentDashboard";
import ChildRegistration from "./components/ChildRegistration";
import { CssBaseline, ThemeProvider } from "@mui/material";
import Therapy from "./components/Therapy";
import AutismADHDAssessment from "./components/AutismADHDAssessment";
import ChildProfile from "./components/ChildProfile";
import ParentTherapyView from "./components/ParentTherapyView";
import ProtectedRoute from "./components/ProtectedRoute";
import ChildReport from "./components/ChildReport";

import "./i18n"; // Import the i18n configuration
import theme from "./theme"; // Import our massive custom UI theme

function App() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router basename="/admin">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />

            {/* Doctor/Therapist Routes */}
            <Route
              path="/doctor-dashboard"
              element={
                <ProtectedRoute allowedRoles={["doctor", "admin", "occupational", "behavioral", "speech"]}>
                  <DoctorDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/register-child"
              element={
                <ProtectedRoute allowedRoles={["doctor", "admin", "occupational", "behavioral", "speech"]}>
                  <ChildRegistration />
                </ProtectedRoute>
              }
            />
            <Route
              path="/child-profile/:childId"
              element={
                <ProtectedRoute allowedRoles={["doctor", "admin", "occupational", "behavioral", "speech"]}>
                  <ChildProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/assessment/:childId"
              element={
                <ProtectedRoute allowedRoles={["doctor", "admin", "occupational", "behavioral", "speech"]}>
                  <AutismADHDAssessment />
                </ProtectedRoute>
              }
            />
            <Route
              path="/therapy/:childId"
              element={
                <ProtectedRoute allowedRoles={["doctor", "admin", "occupational", "behavioral", "speech"]}>
                  <Therapy />
                </ProtectedRoute>
              }
            />
            <Route
              path="/therapy/:childId/:therapyTypeId"
              element={
                <ProtectedRoute allowedRoles={["doctor", "admin", "occupational", "behavioral", "speech"]}>
                  <Therapy />
                </ProtectedRoute>
              }
            />
            <Route
              path="/child-report/:childId"
              element={
                <ProtectedRoute allowedRoles={["doctor", "admin", "occupational", "behavioral", "speech", "parent"]}>
                  <ChildReport />
                </ProtectedRoute>
              }
            />

            {/* Parent Routes */}
            <Route
              path="/parent-dashboard"
              element={
                <ProtectedRoute allowedRoles={["parent"]}>
                  <ParentDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/parent-therapy/:childId"
              element={
                <ProtectedRoute allowedRoles={["parent"]}>
                  <ParentTherapyView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/parent-therapy/:childId/:therapyTypeId"
              element={
                <ProtectedRoute allowedRoles={["parent"]}>
                  <ParentTherapyView />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </ThemeProvider>
    </Suspense>
  );
}

export default App;
